import {
    checkExistingUser,
    CheckExistingUserModel,
    CheckExistingUserParameter,
} from "@carotek/Services/CheckExistingUserService";
import { ApiHandler, createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";

type HandlerType = ApiHandler<CheckExistingUserParameter, CheckExistingUserModel>;

export const RequestExistingUserCheck: HandlerType = async props => {
    const result = await checkExistingUser(props.parameter);
    props.apiResult = result;
};

const userCheckChain = [RequestExistingUserCheck];

const checkIfUserExists = createHandlerChainRunner(userCheckChain, "CheckUserExistsByEmail");
export default checkIfUserExists;
